import { cloneDeep } from 'lodash';
import { defineTransform } from '../transform';

function SetMetadataTransform(editor, op) {
  const { key } = op.properties;

  if (!editor.metadata) {
    editor.metadata = {};
  }

  if (!Object.hasOwn(editor.metadata, key)) return;
  // Should not be able to set annotations key. Also blocked in Permissions.js
  // by validateSlateV2Operation().
  if (key === 'annotations') return;

  editor.metadata[key] = op.newProperties.value;
}

export default SetMetadataTransform;

// Define transformations against metadata operations
defineTransform('set_metadata', 'add_metadata', (op1, op2, side) => {
  if (op1.properties.key !== op2.metadata.key) return op1;

  return {
    ...cloneDeep(op1),
    properties: {
      key: op2.metadata.key,
      value: op2.metadata.value,
    },
  };
});

defineTransform('set_metadata', 'remove_metadata', (op1, op2, side) => {
  // If operating on the same key, defer to the remove.
  if (op1.properties.key === op2.metadata.key) return;

  // If the key is not the same, there's no conflict.
  return op1;
});

defineTransform('set_metadata', 'set_metadata', (op1, op2, side) => {
  if (op1.properties.key !== op2.properties.key) return op1;

  const newProperties =
    side === 'left'
      ? { ...op2.newProperties, ...op1.newProperties }
      : { ...op1.newProperties, ...op2.newProperties };

  return {
    ...cloneDeep(op1),
    newProperties,
  };
});

// Define transformations against standard Slate operations
// These operations don't affect metadata, so we just return op1
defineTransform('set_metadata', 'insert_text', (op1, op2, side) => op1);
defineTransform('set_metadata', 'remove_text', (op1, op2, side) => op1);
defineTransform('set_metadata', 'split_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'merge_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'move_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'insert_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'remove_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'set_node', (op1, op2, side) => op1);
defineTransform('set_metadata', 'add_mark', (op1, op2, side) => op1);
defineTransform('set_metadata', 'remove_mark', (op1, op2, side) => op1);
defineTransform('set_metadata', 'set_mark', (op1, op2, side) => op1);
defineTransform('set_metadata', 'set_selection', (op1, op2, side) => op1);

// Define transformations against annotation operations
defineTransform('set_metadata', 'add_annotation', (op1, op2, side) => op1);
defineTransform('set_metadata', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('set_metadata', 'set_annotation', (op1, op2, side) => op1);
